import React from 'react';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import AboutPage from '../components/about/AboutPage';

const About = () => (
  <div className="min-h-screen site-root">
    <Navigation />
    <AboutPage />
    <Footer />
  </div>
);

export default About;
